import { cn } from "@/lib/utils";

/**
 * Max-width container with responsive padding. Uses design tokens.
 */
export function Container({ className, as: As = "div", ...props }) {
  return (
    <As
      className={cn(
        "max-w-container mx-auto px-4 sm:px-6 lg:px-8",
        className
      )}
      data-testid="container"
      {...props}
    />
  );
}
